import { createReducer } from '../utils';

const initState = false;

export default createReducer(initState, {
  RECEIVE_SEARCH_RESULTS: () => initState,
  RECEIVE_CASE_DATA_OF_CASE_LOOKUP: () => initState,
  RESET_SEARCH_RESULTS: () => initState,
  UPDATE_FILTERS: () => initState,
  RESET_FILTERS: () => initState,
  REQUEST_CASE_DATA_OF_CASE_LOOKUP: () => true,
  RECEIVE_CASE_DATA: () => initState,
  REQUEST_CASE_DATA: () => true,
  REQUEST_VIEW_SEARCH: () => true,
  REQUEST_BANKRUPTCY_SEARCH: () => true,
  REQUEST_BANKRUPTCY_LOCAL_SEARCH: () => true,
  REQUEST_APPELLATE_SEARCH: () => true,
  REQUEST_CIVIL_SEARCH: () => true,
  REQUEST_CRIMINAL_SEARCH: () => true,
  VALIDATION_ERROR: () => false,
  SERVICE_ERROR: () => false,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/loadingSpinner.js